import React from "react";
import SectionHeader from "./SectionHeader";
import InputField from "./../common/InputField";

function PersonalInfoSection() {
  return (
    <section className="mt-6 w-full max-md:max-w-full">
      <SectionHeader icon="user-square" title="Personal Data" />
      <div className="mt-4 w-full max-md:max-w-full">
        <div className="flex flex-wrap gap-6 items-start w-full text-sm leading-loose max-md:max-w-full">
          <InputField
            label="First name"
            placeholder="First name"
            required
            className="flex-1 shrink basis-0 min-w-60"
          />
          <InputField
            label="family name"
            placeholder="family name"
            required
            className="flex-1 shrink basis-0 min-w-60"
          />
          <InputField
            label="Salutation"
            placeholder="company"
            required
            dropdown
            className="flex-1 shrink whitespace-nowrap basis-0 min-w-60"
          />
        </div>
        <div className="flex gap-6 items-start mt-6 w-full max-md:max-w-full">
          <InputField
            label="Profile/introduction text"
            placeholder="Profile/introduction text"
            multiline
            characterCount="0/100"
            className="flex-1 shrink w-full basis-0 min-w-60 max-md:max-w-full"
          />
        </div>
      </div>
    </section>
  );
}

export default PersonalInfoSection;
